import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { ChurnFlowSolutionIconVariant } from '@core/churn-flow-types';

@Component({
  selector: 'tlc-churn-flow-solution-icon',
  templateUrl: './churn-flow-solution-icon.component.html',
  styleUrls: ['./churn-flow-solution-icon.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChurnFlowSolutionIconComponent {
  public variant = input.required<ChurnFlowSolutionIconVariant>();
}
